import { createSlice } from "@reduxjs/toolkit";

const rememberMeSlice = createSlice({
  name: "rememberMe",
  initialState: {
    isRemember: localStorage.getItem("rememberMe") === "true" || false,
  },
  reducers: {
    rememberMe: (state, action) => {
      state.isRemember = action.payload.isRemember;
    },
  },
});

export const { rememberMe } = rememberMeSlice.actions;
export default rememberMeSlice.reducer;
